import React from "react";
import "./about-3.css"; // Make sure to include CSS file
 
const title = (
    <h2 className="about-heading">
        <span>About</span> Kalakakshaaha
    </h2>
);
 
const desc =
    "Kalakakshaaha is a creative learning platform built to preserve and promote India’s cultural and performing arts. We offer structured learning programs in dance, music, drama, and fine arts with expert tutors guiding thousands of students every year.";
 
const detailsList = [
    { leftText: "Founded", clone: ":", rightText: "2018" },
    { leftText: "Focus Areas", clone: ":", rightText: "Dance, Music, Drama, Fine Arts" },
    { leftText: "Goal", clone: ":", rightText: "To inspire creativity & celebrate Indian culture" },
    { leftText: "Support", clone: ":", rightText: "Online / Offline / Hybrid" },
    { leftText: "Mail", clone: ":", rightText: "support@kalakakshaaha.com" },
    { leftText: "Location", clone: ":", rightText: "Hyderabad, India" },
];
 
const countList = [
    { iconName: "icofont-users-alt-4", count: "10000", desc: "Students Trained" },
    { iconName: "icofont-graduate-alt", count: "150", desc: "Certified Tutors" },
    { iconName: "icofont-notification", count: "80", desc: "Art Programs Offered" },
];
 
const testimonialList = [
    {
        name: "Aaradhya",
        text: "The best platform to learn Bharatanatyam! The tutors are extremely professional and supportive.",
        img: "/assets/images/team/01.png"
    },
    {
        name: "Siddharth",
        text: "Joining Kalakakshaaha improved my singing tremendously. Highly recommended!",
        img: "/assets/images/team/02.png"
    },
    {
        name: "Meghana",
        text: "Amazing drama classes! The teaching style is very interactive and fun.",
        img: "/assets/images/team/03.png"
    }
];
 
const AboutThree = () => {
    return (
        <section className="about-section style-4 padding-tb">
            <div className="container">
 
                <div className="about-items">
 
                    {/* LEFT IMAGE */}
                    <div className="about-item about-img-box">
                        <img
                            src="/assets/images/arts/acting-01.jpg"
                            alt="Kalakakshaaha Story"
                            className="story-img"
                        />
                    </div>
 
                    {/* ABOUT CONTENT */}
                    <div className="about-item">
                        <div className="about-content">
                            {title}
                            <p className="about-description">{desc}</p>
 
                            <h4 className="about-subheading">Our Mission</h4>
                            <p>To make arts education engaging, accessible, and rooted in culture.</p>
 
                            <h4 className="about-subheading">Our Vision</h4>
                            <p>To become India’s biggest platform for learning cultural & performing arts.</p>
 
                            <h4 className="about-subheading">Who We Are</h4>
                            <p>
                                We connect passionate learners with certified tutors who teach using
                                structured, professional training methods.
                            </p>
 
                            {/* DETAILS LIST */}
                            <ul className="details-list">
                                {detailsList.map((item, idx) => (
                                    <li key={idx}>
                                        <strong>{item.leftText}</strong> {item.clone} {item.rightText}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
 
                    {/* COUNTERS */}
                    <div className="about-item">
                        <div className="counter-part">
                            {countList.map((val, i) => (
                                <div className="count-box" key={i}>
                                    <i className={val.iconName}></i>
                                    <h2>{val.count}+</h2>
                                    <p>{val.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
 
                {/* WHY CHOOSE US */}
                <div className="why-section">
                    <h2>Why Choose Kalakakshaaha?</h2>
                    <div className="why-grid">
 
                        <div className="why-card">
                            <i className="icofont-star"></i>
                            <h4>Expert Tutors</h4>
                            <p>Learn from certified and professional artists.</p>
                        </div>
 
                        <div className="why-card">
                            <i className="icofont-ui-video-chat"></i>
                            <h4>Live & Recorded Sessions</h4>
                            <p>Access lessons anytime, anywhere.</p>
                        </div>
 
                        <div className="why-card">
                            <i className="icofont-paint"></i>
                            <h4>All Art Categories</h4>
                            <p>Dance, Music, Drama, Fine Arts & more.</p>
                        </div>
 
                        <div className="why-card">
                            <i className="icofont-certificate"></i>
                            <h4>Course Certifications</h4>
                            <p>Boost your artistic journey with professional certificates.</p>
                        </div>
 
                    </div>
                </div>
 
                {/* TIMELINE */}
                <div className="timeline-section">
                    <h2>Our Journey</h2>
 
                    <ul className="timeline">
                        <li>
                            <span className="year">2018</span>
                            <p>Kalakakshaaha was founded with 1 Bharatanatyam tutor.</p>
                        </li>
 
                        <li>
                            <span className="year">2020</span>
                            <p>Expanded into music, drama, and painting programs.</p>
                        </li>
 
                        <li>
                            <span className="year">2022</span>
                            <p>Crossed over 5,000 students learning online.</p>
                        </li>
 
                        <li>
                            <span className="year">2024</span>
                            <p>Launched hybrid classes & certified tutor programs.</p>
                        </li>
                    </ul>
                </div>
 
                {/* TESTIMONIALS */}
                <div className="testimonial-section">
                    <h2>What Our Students Say</h2>
 
                    <div className="testimonial-grid">
                        {testimonialList.map((t, index) => (
                            <div className="testimonial-card" key={index}>
                                <img src={t.img} alt={t.name} className="testimonial-img" />
                                <p>"{t.text}"</p>
                                <h4>- {t.name}</h4>
                            </div>
                        ))}
                    </div>
                </div>
 
                {/* CTA SECTION */}
                <div className="cta-section">
                    <h2>Start Your Artistic Journey Today!</h2>
                    <p>Join thousands of learners and grow your talent with the best tutors.</p>
                    <a href="/signup" className="cta-btn">Join Kalakakshaaha</a>
                </div>
 
            </div>
        </section>
    );
};
 
export default AboutThree;